import { getBrandName } from '../brand-name';

export function getCompanyLicense() {
  const brandName = getBrandName();

  switch (brandName){
    case 'tennisi':
      return 'Evros Corporation B.V. License 8048/JAZ2016-017';
    case 'chesnok':
      return null;
    default:
      assertExhaustiveness(brandName);
  }
}
